module.exports = __webpack_public_path__ + "img/uv.dd2b2819.png";